import { z } from 'zod/v3';

export const VideoImportJobDTOSchema = z.object({
  jobId: z.string(),
  flowId: z.string(),
  status: z.enum(['pending', 'processing', 'completed', 'failed']),
  progress: z.number(),
  error: z.string().optional(),
});

export type VideoImportJobDTO = z.infer<typeof VideoImportJobDTOSchema>;

export const LoomImportResultDTOSchema = z.object({
  success: z.boolean(),
  jobs: z.array(z.object({
    jobId: z.string(),
    flowId: z.string(),
    title: z.string(),
  })),
  errors: z.array(z.object({
    videoId: z.string(),
    error: z.string(),
  })).optional(),
});

export type LoomImportResultDTO = z.infer<typeof LoomImportResultDTOSchema>;

export const ProcessVideoFromUrlInputSchema = z.object({
  url: z.string().url(),
  title: z.string().optional(),
});

export type ProcessVideoFromUrlInput = z.infer<typeof ProcessVideoFromUrlInputSchema>;

export const ProcessVideoFromUrlResultSchema = z.object({
  jobId: z.string(),
  flowId: z.string(),
});

export type ProcessVideoFromUrlResult = z.infer<typeof ProcessVideoFromUrlResultSchema>;
